export default {
  // list
  'order_cargo_detail.query.cargoQty': 'cargoQty',
  'order_cargo_detail.query.cargoQty.placeholder': 'Enter cargoQty',
  'order_cargo_detail.column.orderCargoId': 'orderCargoId',
  'order_cargo_detail.column.orderId': 'orderId',
  'order_cargo_detail.column.orderType': 'orderType',
  'order_cargo_detail.column.ladingOrderId': 'ladingOrderId',
  'order_cargo_detail.column.cargoQty': 'cargoQty',
  'order_cargo_detail.column.cargoWeight': 'cargoWeight',
  'order_cargo_detail.column.cargoAttrUniNo': 'cargoAttrUniNo',
  'order_cargo_detail.column.cargoAttrSealNo': 'cargoAttrSealNo',
  'order_cargo_detail.column.cargoAttrLoadBoxDate': 'cargoAttrLoadBoxDate',
  'order_cargo_detail.column.cargoAttrName': 'cargoAttrName',
  'order_cargo_detail.column.entryFlag': 'entryFlag',
  'order_cargo_detail.column.createBy': 'createBy',
  'order_cargo_detail.column.updateBy': 'updateBy',
  'order_cargo_detail.column.createTime': 'createTime',
  'order_cargo_detail.column.updateTime': 'updateTime',
  'order_cargo_detail.column.dataSource': 'dataSource',
  'order_cargo_detail.column.remark': 'remark',
  'order_cargo_detail.column.status': 'status',
  // edit
  'order_cargo_detail.edit.title': 'Edit OrderCargoDetail',
  'order_cargo_detail.add.title': 'Add OrderCargoDetail',
  'order_cargo_detail.edit.success': 'Edit Successful',
  'order_cargo_detail.add.success': 'Add Successful',
  'order_cargo_detail.form.cargoQty.required': 'cargoQty cannot be null',
  'order_cargo_detail.form.cargoWeight.required': 'cargoWeight cannot be null',
  'order_cargo_detail.form.cargoAttrUniNo.required': 'cargoAttrUniNo cannot be null',
  'order_cargo_detail.form.entryFlag.required': 'entryFlag cannot be null',
  'order_cargo_detail.form.cargoQty': 'cargoQty',
  'order_cargo_detail.form.cargoQty.placeholder': 'Enter cargoQty',
  'order_cargo_detail.form.cargoWeight': 'cargoWeight',
  'order_cargo_detail.form.cargoWeight.placeholder': 'Enter cargoWeight',
  'order_cargo_detail.form.cargoAttr': 'cargoAttr',
  'order_cargo_detail.form.cargoAttrUniNo': 'cargoAttrUniNo',
  'order_cargo_detail.form.cargoAttrUniNo.placeholder': 'Enter cargoAttrUniNo',
  'order_cargo_detail.form.cargoAttrSealNo': 'cargoAttrSealNo',
  'order_cargo_detail.form.cargoAttrSealNo.placeholder': 'Enter cargoAttrSealNo',
  'order_cargo_detail.form.cargoAttrLoadBoxDate': 'cargoAttrLoadBoxDate',
  'order_cargo_detail.form.cargoAttrLoadBoxDate.placeholder': 'Enter cargoAttrLoadBoxDate',
  'order_cargo_detail.form.cargoAttrName': 'cargoAttrName',
  'order_cargo_detail.form.cargoAttrName.placeholder': 'Enter cargoAttrName',
  'order_cargo_detail.form.entryFlag': 'entryFlag',
  'order_cargo_detail.form.entryFlag.placeholder': 'Enter entryFlag',
  'order_cargo_detail.form.dataSource': 'dataSource',
  'order_cargo_detail.form.dataSource.placeholder': 'Enter dataSource',
  'order_cargo_detail.form.remark': 'remark',
  'order_cargo_detail.form.remark.placeholder': 'Enter remark',
}
